import React, { useState } from 'react'
import { getApiTargetInfo } from 'core'
import { connect } from 'react-redux'
import CommonScreen from 'admin/component/CommonScreen'

import { intCol, strCol } from '@integec/grid-tools/lib/cols'
import {
  deleteWind2CauseCode,
  getWind2CauseCode,
  updateWind2CauseCode,
} from 'api/pgads'
import { modifiedDateCol, modifierCol } from 'core/HeaderColTypeProps'
import { Label } from 'core/screen-util'
import { Button, Input, InputNumber } from 'antd'

const title = 'Wind Cause Code'

const Wind2Causecode = _ => {
  const [insertEvent, setInsertEvent] = useState(false)
  const InsertComp = ({ insertData = {}, setInsertData, onAdd, onCancel }) => {
    return (
      <div
        style={{
          display: 'grid',
          gridTemplateColumns:
            '200px 200px 100px 200px 100px 200px auto auto auto',
          gap: 10,
        }}
      >
        <div>
          <Label style={{ display: 'inline', float: 'right' }}>System :</Label>
          <span style={{ color: 'red', marginRight: '2px', float: 'right' }}>
            *
          </span>
        </div>

        {/* <Label>System :</Label> */}
        <Input
          value={insertData.system}
          data-cy="system"
          onChange={e =>
            setInsertData({
              ...insertData,
              system: e.target.value,
            })
          }
        />
        <div>
          <Label style={{ display: 'inline', float: 'right' }}>
            Sub System :
          </Label>
          <span style={{ color: 'red', marginRight: '2px', float: 'right' }}>
            *
          </span>
        </div>

        {/* <Label>Sub System :</Label> */}
        <Input
          value={insertData.subsystem}
          data-cy="subsystem"
          onChange={e =>
            setInsertData({
              ...insertData,
              subsystem: e.target.value,
            })
          }
        />
        <div>
          <Label style={{ display: 'inline', float: 'right' }}>
            Cause Code :
          </Label>
          <span style={{ color: 'red', marginRight: '2px', float: 'right' }}>
            *
          </span>
        </div>

        {/* <Label>Cause Code :</Label> */}
        <InputNumber
          value={insertData.causecode}
          data-cy="causecode"
          onChange={causecode =>
            setInsertData({
              ...insertData,
              causecode,
            })
          }
        />
        <div style={{ gridColumnEnd: 'span 3' }} />
        <div>
          <Label style={{ display: 'inline', float: 'right' }}>
            Cause Code Description :
          </Label>
          <span style={{ color: 'red', marginRight: '2px', float: 'right' }}>
            *
          </span>
        </div>
        {/* <Label>Cause Code Description :</Label> */}
        <Input
          style={{ gridColumnEnd: 'span 5' }}
          data-cy="causecodedescription"
          value={insertData.description}
          onChange={e =>
            setInsertData({
              ...insertData,
              description: e.target.value,
            })
          }
        />

        <Button type="primary" onClick={() => onAdd(true)}>
          Add
        </Button>
        <Button type="primary" onClick={() => onAdd(false)}>
          Add & Hide
        </Button>
        <Button type="danger" onClick={onCancel}>
          Cancel
        </Button>
      </div>
    )
  }

  return (
    <CommonScreen
      title={title}
      header={Wind2CausecodeHeaders}
      saveTask={updateWind2CauseCode}
      retrieveTask={getWind2CauseCode}
      deleteTask={deleteWind2CauseCode}
      autoRetrieve
      // widthOffset={50}
      insertComp={insertEvent && InsertComp}
      insertCompHeight={150}
      onInsertEvent={b => setInsertEvent(b)}
      autoFixColByKey={false}
      headerRowHeight={30}
      totalWidth={150 + 650 + 700 + 150}
      sortOptions={Wind2CausecodeHeaders}
    />
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
})

export default connect(mapStateToProps)(Wind2Causecode)

const Wind2CausecodeHeaders = [
  strCol({
    ident: 'system',
    display: 'System',
    isKey: true,
    width: 250,
    // ellipsis: true,
    // alignment: 'left',
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'subsystem',
    display: 'Sub System',
    isKey: true,
    sortOrder: 'asc',
    width: 250,
  }),
  intCol({
    ident: 'causecode',
    display: 'Cause Code',
    isKey: true,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'description',
    display: 'Cause Code Description',
    isFiltered: true,
    width: 700,
    ellipsis: true,
    alignment: 'left',
  }),
  modifierCol,
  modifiedDateCol,
]
